
/**
 * @export
 * @enum {string}
 */
export enum DateFormat {
    MMDDYYYY = 'MMDDYYYY',
    DDMMYYYY = 'DDMMYYYY',
    YYYYMMDD = 'YYYYMMDD'
}